import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import AdminReviewsForm from '../../../components/siteadmin/AdminReviewsForm';

import s from './WriteReview.css';

const WriteReview = (props) => {

    const { title } = props;

    return (
        <AdminReviewsForm title={title} />
    );
}

WriteReview.propTypes = {
    title: PropTypes.string.isRequired
};

WriteReview.defaultProps = {
    data: {
        loading: true
    }
};

export default withStyles(s)(WriteReview);